// extracted by mini-css-extract-plugin
export default {"wrapper":"BH","content":"CH","firstSection":"EH","text":"FH","table":"GH","tableText":"HH","row":"IH","column_2":"JH","column_1":"KH","column_3":"LH"};
    if(module.hot) {
      // 1715091679797
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  